import React from "react";
import { Box, Typography } from "@mui/material";

const titleSx = { mt: 3, mb: 1, fontWeight: 700 };
const sectionTitleSx = { mt: 4, mb: 1, fontWeight: 700 };
const labelSx = { width: "180px", fontWeight: 700, flexShrink: 0 };
const valueSx = {
  flex: 1,
  borderBottom: "1px solid #999",
  minHeight: "20px",
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
};
const rowSx = { display: "flex", gap: 12, mb: 1.2, alignItems: "flex-start" };
const gridSx = {
  display: "grid",
  gridTemplateColumns: "180px 1fr 180px 1fr",
  gap: "6px 12px",
  mb: 2,
};
const valueOrEmpty = (value) => value ?? "";
const LabeledRow = ({ label, value }) => (
  <Box sx={rowSx}>
    <Typography sx={labelSx}>{label}</Typography>
    <Box sx={valueSx}>{valueOrEmpty(value)}</Box>
  </Box>
);
const sameAsLabel = (value) => {
  if (value === "same") return "同じ";
  if (value === "different") return "異なる";
  return "";
};

const ContactGrid = ({ rows }) => (
  <Box sx={gridSx}>
    {rows.map(([label, value]) => (
      <React.Fragment key={label}>
        <Box sx={{ fontWeight: 700 }}>{label}</Box>
        <Box sx={valueSx}>{valueOrEmpty(value)}</Box>
      </React.Fragment>
    ))}
  </Box>
);

const Comp6PDF = ({ elecData, elecItems = [] }) => {
  if (!elecData) return null;

  const formData = elecData.o6?.[0] ?? elecData;
  const details = formData.details ?? [];

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 3 }}>
        電気備品レンタル申請
      </Typography>

      <LabeledRow label="小間番号" value={elecData.booth_number} />
      <LabeledRow label="会社名" value={elecData.company_name} />
      <LabeledRow label="部署" value={elecData.department} />
      <LabeledRow label="担当者名" value={elecData.user_name} />
      <LabeledRow label="郵便番号" value={elecData.zip_code} />
      <LabeledRow label="住所" value={elecData.address} />
      <LabeledRow label="電話番号" value={elecData.phone_number} />
      <LabeledRow label="メールアドレス" value={elecData.email} />

      <Typography sx={sectionTitleSx}>担当者情報</Typography>
      <LabeledRow label="出展者情報と同じ" value={sameAsLabel(formData.same_ex_6)} />
      <ContactGrid
        rows={[
          ["担当者名", formData.user_6_name],
          ["部署", formData.user_6_department],
          ["会社電話番号", formData.user_6_phone],
          ["携帯電話番号", formData.user_6_tel],
        ]}
      />

      <Typography sx={sectionTitleSx}>請求先情報</Typography>
      <LabeledRow label="出展者情報と同じ" value={sameAsLabel(formData.same_in_6)} />
      <ContactGrid
        rows={[
          ["会社名", formData.invoice_company_name],
          ["担当者名", formData.invoice_user_name],
          ["メールアドレス", formData.invoice_email],
          ["郵便番号", formData.invoice_zip],
          ["住所", formData.invoice_address],
          ["電話番号", formData.invoice_tel],
          ["FAX番号", formData.invoice_fax],
        ]}
      />
      {details.map((detail, index) => {
        const item = elecItems.find((candidate) => candidate.elec_item_id === detail.elec_item_id);
        return (
          <Box key={`elec-${index}`} sx={{ mb: 2, pl: 1 }}>
            <Box sx={rowSx}>
              <Typography sx={labelSx}>品目</Typography>
              <Box sx={valueSx}>{item?.elec_item_name || detail.elec_item_id || ""}</Box>
            </Box>
            <Box sx={rowSx}>
              <Typography sx={labelSx}>数量</Typography>
              <Box sx={valueSx}>{detail.number || ""}</Box>
            </Box>
          </Box>
        );
      })}

      <Box sx={rowSx}>
        <Typography sx={labelSx}>合計金額</Typography>
        <Box sx={valueSx}>{formData.elec_total || ""}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>備考</Typography>
        <Box sx={valueSx}>{formData.alfa_text || ""}</Box>
      </Box>
    </Box>
  );
};

export default Comp6PDF;